<template>
  <div class="card" :style="{background: render.title ? '#FBFBFB' : '#fff', cursor: render.title ? 'pointer' : '' }" v-if="render">
    <div class="left">
      <div ref="img" class="img" :style="renderImageStyle"></div>
    </div>
    <div class="right">
       <p class="title">{{render.title}}</p>
       <p class="sub-title">{{render.content}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: ['render'],
  computed: {
    renderImageStyle() {
      return { backgroundImage: `url(${this.replaceHTTPResource(this.render.icon)})` }
    }
  },
}
</script>

<style scoped lang="scss">
.card {
  display: flex;
  align-items: center;
  background: #FBFBFB;
  border-radius: 8px;
  height: 160px;
  padding-left: 40px;
  padding-right: 40px;
  .left {
    .img {
      width: 48px;
      height: 48px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 20px;
    }
  }
  .right {
    .title {
      font-size: 22px;
      line-height: 22px;
      color: #222222;
    }
    .sub-title {
      margin-top: 10px;
      font-size: 16px;
      line-height: 24px;
      color: #999999;
    }
  }
}
</style>